<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" class="flex">
        <span>补贴单号</span>
        <el-input v-model="search.subsidyNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>售后工单编号</span>
        <el-input v-model="search.smsNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>销售单行号</span>
        <el-input v-model="search.salesNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>发放状态</span>
        <el-select
          v-model="payType"
          placeholder="渠道"
          clearable
          style="width:35%"
        >
          <el-option
            v-for="(item, index) in PayTypeEnum"
            :key="index"
            :label="item.description"
            :value="item.enumCode"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="payType==0"
          v-model="distributionState"
          placeholder="请选择状态"
          clearable
          style="width:65%"
          @change="changeDistributionState"
          multiple
          :disabled="!payType"
        >
          <el-option
            v-for="(item, index) in distributionStateList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          :disabled="!payType"
          v-model="onlineStatusList"
          placeholder="请选择状态"
          clearable
          style="width:65%"
          multiple
        >
          <el-option
            v-for="(item, index) in OldMachineSubsidyOnlineStatusEnum"
            :key="index"
            :label="item.description"
            :value="item.enumCode"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>补贴类型</span>
        <el-select
          v-model="search.subsidyType"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in subsidyTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>旧机品牌</span>
        <el-select
          v-model="search.oldMachineBrand"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in oldMachineBrandList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>旧机品类</span>
        <el-select
          v-model="search.oldMachineType"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in oldMachineCategoryList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>网点编号</span>
        <el-input v-model="search.outletsNo" placeholder="请输入"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>网点名称</span>
        <el-input v-model="search.outletsName" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>收款人姓名</span>
        <el-input v-model="search.payeeName" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>收款人手机号</span>
        <el-input v-model="search.payeeTel" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>渠道</span>
        <el-input v-model="search.channel" placeholder="请输入"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>鉴定时间</span>
        <el-date-picker
          v-model="appraisalTime"
          clearable
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="6" class="flex">
        <span>来源系统</span>
        <el-select
          v-model="search.sourceSystem"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in sourceSystemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="button-container">
      <el-button type="primary" size="medium" @click="getList">查询</el-button>
      <el-button size="medium" @click="resetForm">重置</el-button>
      <el-button size="medium" @click="exportExcel">导出</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="补贴单号"
        prop="subsidyNo"
        width="180"
      ></el-table-column>
      <el-table-column label="补贴类型" prop="outletsName" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.subsidyType === 1">以旧换新</span>
          <span v-if="scope.row.subsidyType === 2">回收</span>
        </template>
      </el-table-column>
      <el-table-column
        label="来源系统"
        prop="sourceSystem"
        width="120"
      ></el-table-column>
      <el-table-column
        label="发放状态"
        prop="statusDesc"
        width="120"
      ></el-table-column>
      <el-table-column
        label="旧机品牌"
        prop="oldMachineBrand"
        width="120"
      ></el-table-column>
      <el-table-column
        label="旧机品类"
        prop="oldMachineTypeName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="旧机规格"
        prop="oldMachineSpecification"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="收款人姓名"
        prop="payeeName"
        width="200"
      ></el-table-column>
      <el-table-column
        label="收款人手机号"
        prop="payeeTel"
        width="120"
      ></el-table-column>
      <el-table-column
        label="鉴定补贴金额"
        prop="subsidyAmount"
        width="120"
      ></el-table-column>
      <el-table-column
        label="售后工单号"
        prop="infoNo"
        width="140"
      ></el-table-column>
      <el-table-column
        label="销售单行号"
        prop="salesNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="渠道"
        prop="channel"
        width="120"
      ></el-table-column>
      <el-table-column
        label="网点编号"
        prop="outletsNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="网点名称"
        prop="outletsName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="鉴定时间"
        prop="appraisalDate"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import enumMixin from '../COldForNewService/enumMixin';
export default {
  props: {},
  mixins: [enumMixin],
  data() {
    return {
      // 表格数据
      list: [],
      total: 0, //列表总条数
      listLoading: false,
      search: {
        // 补贴单号
        subsidyNo: "",
        // 售后工单号
        smsNo: "",
        // 销售单号
        salesNo: "",
        // 补贴类型
        subsidyType: "",
        // 旧机品牌
        oldMachineBrand: "",
        // 旧机类型
        oldMachineType: "",
        // 网点编码
        outletsNo: "",
        // 网点名称
        outletsName: "",
        // 收款人姓名
        payeeName: "",
        // 收款人电话
        payeeTel: "",
        // 渠道
        channel: "",
        // 鉴定开始时间
        appraisalStartDate: "",
        // 鉴定结束时间
        appraisalEndDate: "",
        // 来源系统
        sourceSystem: "",
        // 页码
        currPage: 1,
        // 条数
        pageSize: 10
      },
      // 鉴定时间
      appraisalTime: [],

      // 默认发放状态
      payType:'',
      onlineStatusList:[],
      distributionState: [],
      // 发放状态列表
      distributionStateList: [
        {
          label: "待填写收款信息",
          value: 1
        },
        {
          label: "待业务审核",
          value: 2
        },
        {
          label: "补贴待发放",
          value: 3
        },
        {
          label: "补贴发放中",
          value: 4
        },
        {
          label: "待开票",
          value: 5
        },
        {
          label: "补贴发放失败",
          value: 6
        },
        {
          label: "开票完成",
          value: 7
        },
        {
          label: "已关闭",
          value: 8
        },
        {
          label: "审核驳回",
          value: 21
        },
      ],
      // 补贴类型
      subsidyTypeList: [
        {
          label: "以旧换新",
          value: 1
        },
        {
          label: "回收",
          value: 2
        }
      ],
      // 旧机品牌
      oldMachineBrandList: [
        {
          label: "格力",
          value: "GREE"
        },
        {
          label: "非格力",
          value: "OTHER"
        }
      ],
      // 旧机品类
      oldMachineCategoryList: [
        {
          label: "家用空调",
          value: 101
        },
        {
          label: "电视机",
          value: 102
        },
        {
          label: "热水器",
          value: 103
        },
        {
          label: "电脑",
          value: 104
        },
        {
          label: "冰箱",
          value: 106
        },
        {
          label: "壁挂炉",
          value: 109
        },
        {
          label: "厨大电",
          value: 115
        },
        {
          label: "洗衣机",
          value: 117
        }
      ],
      // 来源系统
      sourceSystemList: [
        {
          label: "4.0",
          value: "4.0"
        },
        {
          label: "3.0",
          value: "3.0"
        }
      ],
      isEdit: false
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  methods: {
    //跳转到详情页
    goDetail(rowData) {
      console.log("看看详情数据", rowData);
      this.$router.push({
        path: "/oldMachineSubsidy/orderDetail",
        query: {
          orderNo: rowData.subsidyNo
        }
      });
    },
    // 获取列表数据
    async getList() {
      this.search.statusList = this.distributionState
        ? this.distributionState
        : [];
      this.search.payType = this.payType
        ? Number(this.payType)
        : '';
      this.search.onlineStatusList = this.onlineStatusList
        ? this.onlineStatusList
        : [];
      if (this.appraisalTime && this.appraisalTime.length !== 0) {
        this.search.appraisalStartDate = this.appraisalTime[0];
        this.search.appraisalEndDate = this.appraisalTime[1];
      } else {
        this.search.appraisalStartDate = "";
        this.search.appraisalEndDate = "";
      }
      let params = this.global.clearEmptyParam(this.search);
      this.list = [];
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/getOldMachineRepertoryByOutletsNo",
        params
      ).then(res => {
        if (res.statusCode === 200) {
          console.log("业务审核数据", res.data);
          // 处理旧机品类
          if (res.data && res.data.length !== 0) {
            res.data.forEach(item => {
              if (item.oldMachineType === 101) {
                item.oldMachineTypeName = "家用空调";
              } else if (item.oldMachineType === 102) {
                item.oldMachineTypeName = "电视机";
              } else if (item.oldMachineType === 103) {
                item.oldMachineTypeName = "热水器";
              } else if (item.oldMachineType === 104) {
                item.oldMachineTypeName = "电脑";
              } else if (item.oldMachineType === 106) {
                item.oldMachineTypeName = "冰箱";
              } else if (item.oldMachineType === 109) {
                item.oldMachineTypeName = "壁挂炉";
              } else if (item.oldMachineType === 115) {
                item.oldMachineTypeName = "厨大电";
              } else if (item.oldMachineType === 117) {
                item.oldMachineTypeName = "洗衣机";
              }
            });
          }
          this.list = res.data;
          this.total = res.total || 0;
        }
      });
    },
    // 改变发放状态
    changeDistributionState(val) {
      console.log("改变发放状态", val);
      if (val === 2) {
        this.tabActiveName = "待业务审核";
      } else if (val === "") {
        this.tabActiveName = "全部";
      } else {
        this.tabActiveName = "";
      }
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    resetForm() {
      this.search = this.$options.data().search;
      this.onlineStatusList = [];
      this.payType = "";
      this.appraisalTime = [];
      this.distributionState = "";
      this.getList();
    },
    // 导出
    exportExcel() {
      this.search.statusList = this.distributionState
        ? this.distributionState
        : [];
      if (this.appraisalTime && this.appraisalTime.length !== 0) {
        this.search.appraisalStartDate = this.appraisalTime[0];
        this.search.appraisalEndDate = this.appraisalTime[1];
      } else {
        this.search.appraisalStartDate = "";
        this.search.appraisalEndDate = "";
      }

      let params = this.search;
        let url = `/autoapp-default-server-recovery/api/oldMachineSubsidy/exportVerify`;
        this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.row-bg {
  margin-bottom: 15px;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}
.button-container {
  margin-bottom: 15px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/subsidyDistributionSearch.vue